<template>
    <header class="hero">
        <section class="hero--body grid-container">
            <h1 class="seo">映画『寝ても覚めても』公式サイト</h1>

            <div class="sns_block">
                <ul class="grid-x align-middle align-center">
                    <li class="cell shrink">
                        <a href="https://www.instagram.com/netemosametemo_movie/" class="sns_block--link" title="Instagram" target="_blank"><svg class="icon icon-instagram"><use xlink:href="#icon-instagram"></use></svg></a>
                    </li>
                    <li class="cell shrink">
                        <a href="https://twitter.com/netesame_movie" class="sns_block--link" title="Twitter" target="_blank"><svg class="icon icon-twitter"><use xlink:href="#icon-twitter"></use></svg></a>
                    </li>
                    <li class="cell shrink">
                        <a href="https://www.facebook.com/寝ても覚めても-162391107913166" class="sns_block--link" title="Facebook" target="_blank"><svg class="icon icon-facebook"><use xlink:href="#icon-facebook"></use></svg></a>
                    </li>
                </ul>
            </div>

            <a class="early_work_banner" href="/netemosametemo/hamaguchi/" title="『寝ても覚めても』公開記念 濱口竜介アーリー・ワークス">
                <picture class="early_work_banner--image">
                    <source srcset="static/img/early_works_banner_pc.jpg"
                            media="(min-width: 640px)">
                    <img src="/netemosametemo/static/img/early_works_banner_sp.jpg" alt="『寝ても覚めても』公開記念 濱口竜介アーリー・ワークス">
                </picture>
            </a>
        </section>

        <p class="hero--info">大ヒット上映中！</p>
    </header>
</template>

<script>

export default {
    name: 'hero',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Hero.vue